import React from "react";

import { useLocalStorage } from "../../../hooks";
import { userState } from "../../../redux/reducers/userReducer";


import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { TwButton, TwInputGroup, TwSelectGroup } from "../../../components/tailwind";
import { useToast } from "../../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading, setSectionLoading } from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings, getUrlForClasses } from "../../../utils/confighelpers";


export default function MigratePurchasesDialog({
    openMigrationCreditDialog,
    setOpenMigrationCreditDialog,
    customerInfo,
    reloadData = () => { },
}) {
    const { addToast, addSuccessToast, addErrorToast } = useToast();
    const location = useLocation();
    const [userToken] = useLocalStorage("userToken");
    const dispatch = useDispatch();
    const loadingReduxState = useSelector(loadingState);
    const userReduxState = useSelector(userState);
    const [classList, setClassList] = React.useState([]);
    const [multiSessionPassList, setMultiSessionPassList] = React.useState([]);
    const [productsList, setProductsList] = React.useState([]);
    const defaultFormData = {
        // "selectedClass": {},
        // "selectedPass": {},
        "selectedProduct": {},
        // "classId": "",
        // "selectedPassId": "",
        "productId": "",
        "migrationCredit": 1,
        // "type": "add", //only for class
        // "isPackage": false, //only for class
        // "isEvent": false, //only for class
        "username": "",
        "fullName": "",
        "email": "",
        "purchaseId": "",
        // "isPaid": true, //only for class
        // "paymentMethod": "NA", //only for class
        // "paymentMode": "Online", //only for class
        // "paymentStatus": "Paid", //only for class
        "paymentMethod": "NA",
        "paymentMode": "NA",
        // "paymentStatus": "Paid"
        "paymentStatus": "Free"
    }
    const [formValues, setFormValues] = React.useState(defaultFormData);
    const [formErrors, setFormErrors] = React.useState({});

    const getListOfClass = async () => {
        let mgClasses = [];
        const manageClassesConfig = {
            method: "get",
            url: `${getUrlForClasses()}listOfClasses?isPackage=${false}&listFor=${userReduxState.businessType}&onlyClassDetail=true`,
        };
        dispatch(setSectionLoading(true));
        const manageClassesRequest = await axiosInstance(manageClassesConfig);
        dispatch(setSectionLoading(false));
        if (manageClassesRequest.status === 200) {
            if (manageClassesRequest.data.data.length) {
                setClassList(manageClassesRequest.data.data);
            }
        }
    };

    const getProductsList = async (page = 1) => {
        const config = {
            method: "get",
            url: `${getUrlForClasses("")}products/list?getall=false&productType=classpass`,
        };
        dispatch(setGlobalLoading(true));
        const productRequest = await axiosInstance(config);
        dispatch(setGlobalLoading(false));
        if (productRequest.status === 200) {
            // console.log("productRequest.data.data", productRequest.data.data.data);

            if (productRequest.data.data.length) {
                setProductsList(productRequest.data.data);
            }
        }
    };

    const handleSubmit = async () => {
        const errors = {};
        // if (!Object.keys(formValues.selectedClass).length) {
        //     errors.selectedClass = "Required!";
        // }
        // if (!Object.keys(formValues.selectedPass).length) {
        //     errors.selectedPass = "Required!";
        // } else if (Object.keys(formValues.selectedPass).length && parseFloat(formValues.selectedPass.amount) > 0) {
        //     errors.selectedPass = "The amount of 'Migration Credit' pass should be zero(0)";
        // }
        if (!Object.keys(formValues.selectedProduct).length) {
            errors.selectedProduct = "Required!";
        }
        // else if (Object.keys(formValues.selectedProduct).length && parseFloat(formValues.selectedProduct.price) > 0) {
        //     errors.selectedProduct = "The price of 'Migration Credit' pass should be zero(0)";
        // }

        if (formValues.migrationCredit <= 0) {
            errors.migrationCredit = "Credit must be greater than 0.";
        }
        if (formValues.migrationCredit % 1 !== 0) {
            errors.migrationCredit = "Please enter decimal value!";
        }
        if (parseInt(formValues.migrationCredit) > parseInt(formValues.selectedProduct.productFields.noOfAllowedSessions)) {
            errors.migrationCredit = `The migration credit for "${formValues.selectedProduct.productFields.passName}" cannot exceed ${parseInt(formValues.selectedProduct.productFields.noOfAllowedSessions)} credits.`;
        }
        setFormErrors({ ...errors });
        if (Object.keys(errors).length > 0) {
            console.log("errors", errors);
            addErrorToast("Please fix errors below", { hideAfter: 3 });
            return;
        }
        setFormValues((prevValues) => ({
            ...prevValues,
            // classId: formValues.selectedClass._id,
            // selectedPassId: formValues.selectedPass._id,
            productId: formValues.selectedProduct._id,
        }));

        let body = {
            ...formValues,
            migrationCredit: parseInt(formValues.migrationCredit),
            // classId: formValues.selectedClass._id,
            // selectedPassId: formValues.selectedPass.passId,
            productId: formValues.selectedProduct._id,
            username: customerInfo?.username || "",
            fullName: customerInfo?.fullName || "",
            email: customerInfo?.email || "",
            paymentStatus: formValues.selectedProduct.price > 0 ? "Free" : "Paid",
        };
        delete body.selectedClass
        delete body.selectedPass
        delete body.selectedProduct

        // console.log("body", body);
        // if (!body.username || !body.fullName || !body.email || !body.classId || !body.selectedPassId) {
        if (!body.username || !body.fullName || !body.email || !body.productId) {
            errors.selectedProduct = "Purchase detail required!";
        }
        setFormErrors({ ...errors });
        if (Object.keys(errors).length > 0) {
            console.log("errors", errors);
            addErrorToast("Please fix errors below", { hideAfter: 3 });
            return;
        }
        let config = {
            method: "post",
            url: `${getUrlForBookings()}purchaseClassPass`,
            data: body,
        };
        // console.log("config.body", body);
        // return;

        dispatch(setGlobalLoading(true));
        dispatch(setActionLoading(true));
        const request = await axiosInstance(config);
        dispatch(setActionLoading(false));
        dispatch(setGlobalLoading(false));

        if (request.status === 200) {
            if (request.data.statusCode === 200) {
                let purchasingInfo = request.data.data;
                reloadData()
                addSuccessToast("Your customer credit migrated successfully");
                setFormValues(defaultFormData);
                setOpenMigrationCreditDialog(false)
                return;
            } else if (request.data.statusCode === 403) {
                addErrorToast(request.data.message);
            }
        } else {
            addErrorToast(request?.data?.message?.errors ? "Something is wrong please try again" : request.data.message);
        }

    };

    React.useEffect(() => {
        (async () => {
            // await getListOfClass();
            await getProductsList();
        })();
    }, []);

    React.useEffect(() => {
        setFormValues((prevValues) => ({
            ...prevValues,
            username: customerInfo?.username || "",
            fullName: customerInfo?.fullName || "",
            email: customerInfo?.email || "",
        }));
    }, [customerInfo]);

    // console.log("customerInfo-1", customerInfo);

    return (
        <div className="flex flex-col w-full  gap-2">
            <div className="flex flex-col gap-2">
                {/* <TwSelectGroup
                    label={"Class"}
                    placeholder={"Select Class"}
                    name={"selectedClass"}
                    // leftIcon={<img src={marker} alt={""} className="w-4" />}
                    options={[{
                        value: "", title: "Select Class...",
                    }, ...classList.length ? classList.map((cls, idx) => {
                        return { value: JSON.stringify(cls), title: cls.className }
                    }) : []]}
                    defaultValue={JSON.stringify(formValues.selectedClass)}
                    value={JSON.stringify(formValues.selectedClass)}
                    onChange={(event) => {
                        setFormErrors({});
                        const newValue = JSON.parse(event.target.value);
                        let tempmultiSessionPassList = newValue?.multiSessionPassList || [];
                        console.log("event.target.value", newValue);
                        console.log("tempmultiSessionPassList", tempmultiSessionPassList);
                        tempmultiSessionPassList = tempmultiSessionPassList.filter((d) => parseFloat(d.amount) <= 0)
                        setMultiSessionPassList(tempmultiSessionPassList)
                        console.log("tempmultiSessionPassList.filter", tempmultiSessionPassList);
                        if (tempmultiSessionPassList.length <= 0) {
                            setFormErrors({ selectedPass: "Please create a 'Migration Credit' pass." });
                        }
                        setFormValues((prevValues) => ({
                            ...prevValues,
                            selectedClass: newValue,
                        }));

                    }}
                    errors={formErrors} />
                <TwSelectGroup
                    label={"Migration Credit Pass"}
                    placeholder={"Select Pass"}
                    name={"selectedPass"}
                    options={[{
                        value: "", title: "Select Pass...",
                    }, ...multiSessionPassList.length ? multiSessionPassList.map((cls, idx) => {
                        return { value: JSON.stringify(cls), title: cls.passName }
                    }) : []]}
                    defaultValue={JSON.stringify(formValues.selectedPass)}
                    value={JSON.stringify(formValues.selectedPass)}
                    onChange={(event) => {
                        const newValue = JSON.parse(event.target.value);
                        console.log("newValue", newValue);
                        setFormValues((prevValues) => ({
                            ...prevValues,
                            selectedPass: newValue,
                        }));

                    }}
                    errors={formErrors} /> */}
                <TwSelectGroup
                    label={"Product"}
                    placeholder={"Select Product"}
                    name={"selectedProduct"}
                    // leftIcon={<img src={marker} alt={""} className="w-4" />}
                    options={[{
                        value: "", title: "Select Product...",
                    }, ...productsList.length ? productsList.filter((d) => /** parseFloat(d.price) <= 0 && **/ d.productName != "free trial credit" && d.productType == "classpass").map((cls, idx) => {
                        return { value: JSON.stringify(cls), title: cls.productName }
                    }) : []]}
                    defaultValue={JSON.stringify(formValues.selectedProduct)}
                    value={JSON.stringify(formValues.selectedProduct)}
                    onChange={(event) => {
                        const newValue = JSON.parse(event.target.value);
                        console.log("newValue", newValue);
                        setFormValues((prevValues) => ({
                            ...prevValues,
                            selectedProduct: newValue,
                        }));

                    }}
                    errors={formErrors} />
                <TwInputGroup
                    label={"Migration Credit"}
                    placeholder={"Credit (in Number)"}
                    type={"number"}
                    name={"migrationCredit"}
                    value={formValues.migrationCredit}
                    onChange={(event) => {
                        setFormValues((prevValues) => ({
                            ...prevValues,
                            migrationCredit: event.target.value,
                        }));

                    }}
                    errors={formErrors}
                    // className="!py-3 md:pl-2.5"
                    helperText="no. of migration credit for this pass"
                />
                <div className={"flex gap-4 justify-center pt-5 w-full sm:w-full sm:max-w-sm md:max-w-lg"}>
                    <TwButton
                        variant={"orange-outline"}
                        className={"w-full"}
                        disabled={loadingReduxState.actionLoading}
                        onClick={() => {
                            setFormValues(defaultFormData);
                            setOpenMigrationCreditDialog(false)
                        }}
                    >
                        Cancel
                    </TwButton>
                    <TwButton
                        variant={"orange"}
                        className={"w-full"}
                        disabled={loadingReduxState.actionLoading}
                        actionLoading={(loadingReduxState.actionLoading)}
                        onClick={() => {
                            handleSubmit();
                        }}
                    >
                        Add credits
                    </TwButton>
                </div>
            </div>
        </div>
    );
}
